import React from "react";
import { useNavigate } from "react-router-dom";

import { useCheckout } from "../../features/Checkout/useCheckout";
import { useSelectMethod } from "../../features/Checkout/useSelectMethod";
import { useCheckoutStore } from "../../store/checkoutStore";

import AddressSection from "../../components/Checkout/AddressSection";
import ShipmentCard from "../../components/Checkout/ShipmentCard";
import Button from "../../components/Button";

export default function CheckoutPage() {
  const navigate = useNavigate();

  const { data: checkoutData, isLoading, isError, error } = useCheckout();
  const { mutate: selectMethod, isPending: isSelectingMethod } = useSelectMethod();

  const destinationAddress = useCheckoutStore((state) => state.destinationAddress);

  const handleSelectMethod = (shipmentId, optionId) => {
    selectMethod({ shipmentId, optionId });
  };

if (isLoading) {
    return (
      <div
        className="flex justify-center items-center h-64 text-gray-600 font-bold"
        dir="rtl"
      >
        در حال بارگذاری اطلاعات سبد خرید و روش‌های تحویل...
      </div>
    );
  }

  if (isError) {
    // افزایش عرض بخش خطا برای هماهنگی با ساختار صفحه
    return (
      <div
        className="max-w-7xl mx-auto my-6 p-4 bg-red-50 text-red-700 rounded-lg text-center"
        dir="rtl"
      >
        خطایی در دریافت اطلاعات رخ داده است:{" "}
        {error?.message || "ارتباط با سرور برقرار نشد."}
      </div>
    );
  }

  const shipments = checkoutData?.shipments || [];

  return (
    /* تغییر مهم: اضافه کردن max-w-7xl (یا max-w-screen-xl) و w-full جهت پر کردن فضا در دسکتاپ */
    <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 my-8 space-y-6" dir="rtl">

      {/* بخش آدرس */}
      <AddressSection address={destinationAddress} />

      {/* بخش محموله‌ها و روش‌های ارسال */}
      <div className="p-6 bg-gray-50 rounded-2xl min-h-[500px] border border-gray-100">
        <h1 className="text-2xl font-bold mb-6 text-gray-800 border-r-4 border-blue-600 pr-3">
          انتخاب شیوه ارسال
        </h1>

        {shipments.length === 0 ? (
          <p className="text-gray-500 text-center py-12 bg-white rounded-xl border border-dashed">
            هیچ محموله‌ای برای ارسال یافت نشد.
          </p>
        ) : (
          /* چیدمان محموله‌ها به صورت لیست عریض */
          <div className="space-y-6">
            {shipments.map((shipment) => (
              <ShipmentCard
                key={shipment.id}
                shipment={shipment}
                onSelectMethod={handleSelectMethod}
                isSelectingMethod={isSelectingMethod}
              />
            ))}
          </div>
        )}

        {/* دکمه عملیات نهایی */}
        <div className="flex justify-end mt-8 pt-4 border-t border-gray-200">
          <Button
            variant="primary"
            onClick={() => navigate("/checkout/review/")}
            disabled={
              isSelectingMethod || shipments.some((shipment) => !shipment.selected_option)
            }
            className="px-10 py-3.5 text-base font-medium shadow-md transition-all"
          >
            ادامه و صورت حساب
          </Button>
        </div>
      </div>
    </div>
  );
}
